import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'dashboard', sv, true, true)
i18n.addResourceBundle('en', 'dashboard', en, true, true)

export function buildDashboardRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/',
      component: lazyRouteComponent(
        () => import('./start/StartPage'),
        'StartPage',
      ),
    }),
  ]
}
